/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsSerialNumberListItem
 */
export interface ControlcenterMelcoModelsSerialNumberListItem {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsSerialNumberListItem
     */
    serial_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsSerialNumberListItem
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsSerialNumberListItem
     */
    product_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsSerialNumberListItem
     */
    product_level_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsSerialNumberListItem
     */
    subscription_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsSerialNumberListItem
     */
    referral_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsSerialNumberListItem
     */
    batch?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoModelsSerialNumberListItem
     */
    cancelled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsSerialNumberListItem
     */
    version_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsSerialNumberListItem
     */
    version_id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsSerialNumberListItem
     */
    type?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsSerialNumberListItem
     */
    affiliate_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsSerialNumberListItem
     */
    affiliate_name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsSerialNumberListItem
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsSerialNumberListItem
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsSerialNumberListItem
     */
    subscription_start_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsSerialNumberListItem
     */
    sub_cancelled_date?: Date | null;
}

export function ControlcenterMelcoModelsSerialNumberListItemFromJSON(json: any): ControlcenterMelcoModelsSerialNumberListItem {
    return ControlcenterMelcoModelsSerialNumberListItemFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsSerialNumberListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsSerialNumberListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'serial_number': !exists(json, 'serial_number') ? undefined : json['serial_number'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'product_name': !exists(json, 'product_name') ? undefined : json['product_name'],
        'product_level_name': !exists(json, 'product_level_name') ? undefined : json['product_level_name'],
        'subscription_code': !exists(json, 'subscription_code') ? undefined : json['subscription_code'],
        'referral_code': !exists(json, 'referral_code') ? undefined : json['referral_code'],
        'batch': !exists(json, 'batch') ? undefined : json['batch'],
        'cancelled': !exists(json, 'cancelled') ? undefined : json['cancelled'],
        'version_number': !exists(json, 'version_number') ? undefined : json['version_number'],
        'version_id': !exists(json, 'version_id') ? undefined : json['version_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'affiliate_code': !exists(json, 'affiliate_code') ? undefined : json['affiliate_code'],
        'affiliate_name': !exists(json, 'affiliate_name') ? undefined : json['affiliate_name'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'subscription_start_date': !exists(json, 'subscription_start_date') ? undefined : (json['subscription_start_date'] === null ? null : new Date(json['subscription_start_date'])),
        'sub_cancelled_date': !exists(json, 'sub_cancelled_date') ? undefined : (json['sub_cancelled_date'] === null ? null : new Date(json['sub_cancelled_date'])),
    };
}

export function ControlcenterMelcoModelsSerialNumberListItemToJSON(value?: ControlcenterMelcoModelsSerialNumberListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'serial_number': value.serial_number,
        'product_code': value.product_code,
        'product_name': value.product_name,
        'product_level_name': value.product_level_name,
        'subscription_code': value.subscription_code,
        'referral_code': value.referral_code,
        'batch': value.batch,
        'cancelled': value.cancelled,
        'version_number': value.version_number,
        'version_id': value.version_id,
        'type': value.type,
        'affiliate_code': value.affiliate_code,
        'affiliate_name': value.affiliate_name,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'subscription_start_date': value.subscription_start_date === undefined ? undefined : (value.subscription_start_date === null ? null : value.subscription_start_date.toISOString()),
        'sub_cancelled_date': value.sub_cancelled_date === undefined ? undefined : (value.sub_cancelled_date === null ? null : value.sub_cancelled_date.toISOString()),
    };
}


